import ContentChartFooter from './ContentChartFooter'
import { withRouter } from 'react-router'

export default withRouter(ContentChartFooter)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartFooter/index.js